// Generated by ReScript, PLEASE EDIT WITH CARE


var importFile = (filename => import('./' + filename));

export {
  importFile ,
}
/* No side effect */
